var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop } from "vue-property-decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { CASE_CHANNEL } from "~/config/enum.config";
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var TelephoneActionHistory = /** @class */ (function (_super) {
    __extends(TelephoneActionHistory, _super);
    function TelephoneActionHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            modify: false,
        };
        _this.fileLists = [];
        _this.srcList = [];
        _this.searchModel = {
            followupBack: "",
            operatorRealName: "",
            followTime: [],
        };
        _this.dataSet = [];
        return _this;
    }
    //重置搜索条件
    TelephoneActionHistory.prototype.resetSearchFelid = function () {
        var form = this.$refs["form"];
        form.resetForm();
    };
    //获取电催行动历史
    TelephoneActionHistory.prototype.refreshData = function () {
        var _this = this;
        this.searchModel.caseId = this.caseId;
        this.searchModel.followupType = CASE_CHANNEL.tel;
        var params = __assign({}, this.searchModel);
        params.followTimeMin = this.$filter.dateRanageFormat(this.searchModel.followTime).start;
        params.followTimeMax = this.$filter.dateRanageFormat(this.searchModel.followTime).end;
        delete params.followTime;
        this.caseOperatorPageService
            .caseFollowupRecord(params, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    TelephoneActionHistory.prototype.activated = function () {
        this.refreshData();
    };
    TelephoneActionHistory.prototype.onClickDetail = function (row) {
        var fileList = JSON.parse(row.files);
        this.dialog.modify = true;
        this.fileLists = fileList.map(function (item) {
            return __assign(__assign({}, item), { operatorRealName: row.operatorRealName });
        });
        this.srcList = fileList.map(function (item) {
            return item.url;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], TelephoneActionHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TelephoneActionHistory.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], TelephoneActionHistory.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneActionHistory.prototype, "caseId", void 0);
    __decorate([
        Prop()
    ], TelephoneActionHistory.prototype, "topInfo", void 0);
    TelephoneActionHistory = __decorate([
        Component
    ], TelephoneActionHistory);
    return TelephoneActionHistory;
}(Vue));
export default TelephoneActionHistory;
